/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Booking Center
 * @export
 */
export const BookingCenter = {
    Gg: 'GG',
    Mc: 'MC',
    Sg: 'SG',
    Ch: 'CH'
} as const;
export type BookingCenter = typeof BookingCenter[keyof typeof BookingCenter];


export function instanceOfBookingCenter(value: any): boolean {
    for (const key in BookingCenter) {
        if (Object.prototype.hasOwnProperty.call(BookingCenter, key)) {
            if (BookingCenter[key as keyof typeof BookingCenter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BookingCenterFromJSON(json: any): BookingCenter {
    return BookingCenterFromJSONTyped(json, false);
}

export function BookingCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingCenter {
    return json as BookingCenter;
}

export function BookingCenterToJSON(value?: BookingCenter | null): any {
    return value as any;
}

export function BookingCenterToJSONTyped(value: any, ignoreDiscriminator: boolean): BookingCenter {
    return value as BookingCenter;
}

